import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=4f7db70f&scoped=true&"
import script from "./Attachment.vue?vue&type=script&lang=js&"
export * from "./Attachment.vue?vue&type=script&lang=js&"
import style0 from "./Attachment.vue?vue&type=style&index=0&id=4f7db70f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7db70f",
  null
  
)

export default component.exports